export default __webpack_public_path__ + "static/media/choco-box@2x.17a97c6e.png";